module.exports = __webpack_public_path__ + "img/logo_AKHLAK.989572cb.jpg";